/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react';
import {Link} from 'react-router-dom';
import {useAuth} from '../../../../app/modules/auth';
import {Languages} from './Languages';
import {toAbsoluteUrl} from '../../../helpers';
import {Button, Modal} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import * as actionsGlobal from 'src/setup/redux/global/Actions';
import * as actionsModal from 'src/setup/redux/modal/Actions';
import ModalItem from './ModalConfig';
import ModalSyncConfig from './ModalSyncConfig';
import {useIntl} from 'react-intl';
const HeaderUserMenu = () => {
  const {currentUser, logout} = useAuth();
  const modalSettingConfig = useSelector((state) => state.modal.modalSettingConfig);
  const intl = useIntl();
  const [modalSyncConfig, setModalSyncConfig] = useState(false);

  const dispatch = useDispatch();
  const handelLogout = () => {
    logout();
    dispatch(actionsGlobal.setCurrentBranch(null));
    dispatch(actionsGlobal.setChooseBranch(false));
  };
  const handleChangeBranch = () => {
    dispatch(actionsGlobal.setChooseBranch(false));
  };

  const setupConfig = () => {
    dispatch(actionsModal.setModalSettingConfig(true));
    //console.log('open config');
  };

  const syncConfig = () => {
    //console.log('open config');
    setModalSyncConfig(true);
  };

  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content d-flex align-items-center px-3'>
            <div className='symbol symbol-50px me-5'>
              <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
            </div>

            <div className='d-flex flex-column'>
              <div className='fw-bolder d-flex align-items-center fs-5'>
                {currentUser?.fullName}
                <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                  {currentUser?.userName}
                </span>
              </div>
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {currentUser?.email}
              </a>
            </div>
          </div>
        </div>

        {/* <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div> */}
        {/* 
      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div>

      <div className='separator my-2'></div> */}

        <Languages />

        <div className='menu-item px-5 my-1'>
          <Link to='/account' className='menu-link px-5'>
            {intl.formatMessage({id: 'ACCOUNT.INFO'})}
          </Link>
        </div>

        <div className='menu-item px-5 my-1'>
          <Link to='#' className=' menu-link px-5' onClick={setupConfig}>
            {intl.formatMessage({id: 'ACCOUNT.SETUPSYSTEM'})}
          </Link>
        </div>

        <div className='menu-item px-5 my-1'>
          <p className=' menu-link px-5' onClick={syncConfig}>
            Thiết lập đồng bộ
          </p>
        </div>

        {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Thông tin tài khoản
        </Link>
      </div> */}

        <div className='menu-item px-5 my-1'>
          <Link to='/branch' className='menu-link px-5' onClick={handleChangeBranch}>
            {intl.formatMessage({id: 'ACCOUNT.CHANGEBRANCH'})}
          </Link>
        </div>

        <div className='menu-item px-5'>
          <a onClick={handelLogout} className='menu-link px-5'>
            {intl.formatMessage({id: 'ACCOUNT.LOGOUT'})}
          </a>
        </div>
      </div>
      {modalSettingConfig ? <ModalItem /> : <></>}
      {modalSyncConfig ? (
        <ModalSyncConfig
          modalSyncConfig={modalSyncConfig}
          setModalSyncConfig={setModalSyncConfig}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export {HeaderUserMenu};
